import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";
import { Button } from "react-bootstrap";
import { Form } from "react-bootstrap";
import Tiptap from "../TipTap/TipTap";
import { CreateAnswer } from "./CreateAnswer";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";

import { useAppStore } from "../../providers/AppStoreProvider";
import { useAPI } from "../../providers/ApiProvider";
import { TOASTIFY_OPTIONS } from "../../config/ReactToastify";

import "./Question.scss";

export const CreateQuestion = observer(({ questionData, questionHandler, isEditing = false }) => {
  const store = useAppStore();
  const api = useAPI();

  const contentRef = useRef(null);
  const explanationRef = useRef(null);
  const scoreRef = useRef(null);
  const answersRef = useRef(null);
  const [typeAnswer, setTypeAnswer] = useState(questionData?.type ?? "single");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (questionData) {
      scoreRef.current.value = questionData.score;

      setTimeout(() => {
        contentRef.current?.setContent(questionData.content);
        explanationRef.current?.setContent(questionData.explanation);
      }, 0);
    }
  }, [questionData]);

  const saveQuestion = async () => {
    setIsLoading(true);
    let data = {
      content: contentRef.current.getHtml(),
      explanation: explanationRef.current.getHtml(),
      type: typeAnswer,
      score: scoreRef.current.value || 10,
      order: store.currentLesson.quiz?.questions?.length,
      answers: answersRef.current.getAnswers(),
    };

    // Validate content
    if (data["content"] === "<p></p>") {
      toast.error("Câu hỏi không được bỏ trống", TOASTIFY_OPTIONS);
      setIsLoading(false);
      return;
    }

    // Validate score
    if (data["score"] <= 0) {
      toast.error("Điểm câu hỏi phải lớn hơn 0", TOASTIFY_OPTIONS);
      setIsLoading(false);
      return;
    }

    let emptyAnswerFound = false;
    let correctAnswerFound = false;
    data["answers"].forEach((answer) => {
      if (answer["content"] === "" && answer["image_url"] === null) {
        emptyAnswerFound = true;
      }
      if (answer["is_correct"]) {
        correctAnswerFound = true;
      }
    });

    // Validate answers
    if (emptyAnswerFound) {
      toast.error("Câu trả lời không được bỏ trống", TOASTIFY_OPTIONS);
      setIsLoading(false);
      return;
    }

    // Validate correct answer
    if (!correctAnswerFound) {
      toast.error("Phải có ít nhất 1 câu trả lời đúng", TOASTIFY_OPTIONS);
      setIsLoading(false);
      return;
    }

    let apiRes;
    if (isEditing) {
      data["id"] = questionData.id;

      apiRes = await api.callApi("updateQuestion", {
        params: { pk: questionData.id },
        body: data,
      });
    } else {
      apiRes = await api.callApi("createQuestion", {
        params: { pk: store.currentLesson.model_id },
        body: data,
      });
    }

    try {
      if (isEditing) {
        store.currentLesson.quiz?.updateQuestion(questionData.id, apiRes.data.data);
      } else {
        store.currentLesson.quiz?.addQuestion(apiRes.data.data);
      }
      store.currentLesson.quiz?.updateScore();
      questionHandler(false);
      toast.success(`${isEditing ? "Cập nhật" : "Tạo"} câu hỏi thành công`, TOASTIFY_OPTIONS);
    } catch (e) {
      console.log(e);
      toast.error(
        `Xảy ra lỗi, không thể ${isEditing ? "cập nhật" : "tạo"} câu hỏi`,
        TOASTIFY_OPTIONS,
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="question rounded-10 p-4 mb-4">
        <div className="">
          <div className="">
            <div className="d-flex flex-row justify-content-between align-items-center">
              <h5 className="fw-bold lh-sm mb-1">Câu hỏi</h5>
              <div className="point rounded fs-7 text-black-50 text-nowrap px-3 py-2">
                <Form.Control
                  ref={scoreRef}
                  type="number"
                  className="score"
                  placeholder="10"
                  defaultValue={10}
                />{" "}
                điểm
              </div>
            </div>

            <Form.Group className="mt-4">
              <Form.Label className="fw-bold">Nội dung câu hỏi</Form.Label>
              <Tiptap ref={contentRef} placeholder="Nội dung câu hỏi" />
            </Form.Group>
          </div>
        </div>
        <div className="answers mt-3">
          <div className="d-flex flex-row justify-content-between align-items-center mb-3">
            <Form.Label className="fw-bold">Câu trả lời</Form.Label>
            <Form.Select
              className="w-auto"
              aria-label="Default select example"
              onChange={(e) => setTypeAnswer(e.target.value)}
              defaultValue={typeAnswer}
            >
              <option value="single">Single choice</option>
              <option value="multiple">Multiple choice</option>
            </Form.Select>
          </div>

          <CreateAnswer
            answersData={questionData?.answers}
            ref={answersRef}
            typeAnswer={typeAnswer}
          />
        </div>

        <Form.Group className="explanation mt-4">
              <Form.Label className="fw-bold">Giải thích</Form.Label>
              <Tiptap ref={explanationRef} placeholder="Giải thích câu trả lời" />
            </Form.Group>

        <div className="d-flex flex-row justify-content-end align-items-center mt-4">
          <Button
            className="cancel-btn outline-0 text-black-50 rounded-pill border-0 p-2 px-4 btn btn-outline me-5"
            onClick={() => questionHandler(false)}
          >
            Huỷ
          </Button>
          <Button
            className="submit-btn rounded-pill border-0"
            onClick={saveQuestion}
            disabled={isLoading}
          >
            {isLoading ? <Spinner animation="border" size="sm" className="me-2" /> : ""}
            {isEditing ? "Lưu" : "Tạo"}
          </Button>
        </div>
      </div>
    </div>
  );
});
